import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { IconLogoNew } from 'icons'

import styles from './Loading.scss'

const Loading = ({ inline, pageLoading }) => {
  const classNames = classnames(
    styles.base,
    { [styles.isPageLoader]: pageLoading },
    { [styles.inline]: inline },
  )

  const iconClassNames = classnames(
    styles.icon,
    { [styles.inlineIcon]: inline },
  )

  const message = 'LOADING'

  return (
    <div className={classNames}>
      <div className={classnames(styles.cell)}>
        <IconLogoNew
          className={iconClassNames}
          size={40}
        />
        {!inline && message}
      </div>
    </div>
  )
}

Loading.propTypes = {
  inline: PropTypes.bool,
  pageLoading: PropTypes.bool,
}

Loading.defaultProps = {
  inline: false,
  pageLoading: false,
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js